import MobileDetect from 'mobile-detect';
import { MOBILE_DEVICE, DESKTOP_DEVICE, TABLET_DEVICE } from './constants';

// @flow
export const BROWSER_ID = {
  desktop: 1,
  mobile: 2,
  tablet: 3,
};

export function getBrowserId(device: string): number {
  return BROWSER_ID[device];
}

export function getDevice(userAgent) {
  const device = new MobileDetect(userAgent);

  if (device.tablet()) {
    return TABLET_DEVICE;
  }

  if (device.mobile()) {
    return MOBILE_DEVICE;
  }

  return DESKTOP_DEVICE;
}

export function isMobileDevice(device) {
  return device === MOBILE_DEVICE;
}

export function isDesktopDevice(device) {
  return device === DESKTOP_DEVICE;
}

/* 
  we receive m, t and c values from google so we need to take care about them.
  If you need more information, contact with media buying team
*/
export function deviceMap(deviceAPIValue) {
  const map = {
    mobile: MOBILE_DEVICE,
    m: MOBILE_DEVICE,
    tablet: TABLET_DEVICE,
    t: TABLET_DEVICE,
    c: DESKTOP_DEVICE,
    desktop: DESKTOP_DEVICE,
  };

  return map[deviceAPIValue] || 'unknown';
}



// WEBPACK FOOTER //
// ./app/request/device/utils.js